import React, { useState, useContext, useEffect } from "react";
import NavMenu from './../navMenu/NavMenu';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { solid } from "@fortawesome/fontawesome-svg-core/import.macro";
import { useStores } from "../../core/stores/rootStore";
import { useTranslation, Trans } from "react-i18next";
import Flag from 'react-world-flags'
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import NavDropdown from 'react-bootstrap/NavDropdown';
import { useNavigate,Link } from "react-router-dom"
import Card from 'react-bootstrap/Card';
import Stack from 'react-bootstrap/Stack';
import { ToastContainer } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import { getUserType, formatDateTime } from './../../utils';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import Button from 'react-bootstrap/Button';
import Badge from 'react-bootstrap/Badge';
import Popover from '@mui/material/Popover';
import { subscribe, publish } from "./../../events";

const PrivateLayout = ({ children }) => {
    const navigate = useNavigate()

    // ES6 module syntax
    const { t, i18n } = useTranslation();

    
    const changeLanguage = lng => {
        i18n.changeLanguage(lng);
        updateLanguage(lng);
    };

    const { appStore, loginStore, usersAdminStore}= useStores();
    const { toggleSidebar } = appStore;
    const { logout, accountInfo } = loginStore;
    const { getNotifications, markNotificationAsRead, updateLanguage } = usersAdminStore;
    const [notifications, setNotifications] = useState([]);
    
    const handleChange = (e) => { changeLanguage(e.target.value); };

    const handleSelection = (event) =>{
        switch (event) {
            case "en":
            case "fr":
                changeLanguage(event);
                break;
            case "logout":                
                logout();
                break;
            case "profile":
                navigate('/profile', { state: { isProfile: true } });
                break;
            default:
                break;
        }
    }
    const [anchorEl, setAnchorEl] = useState(null);

    const deserialize = (obj, key) => {
        var obj = JSON.parse(obj);
        return obj?.[key] ?? "";
    }

    const getKey = (x, key) => deserialize(x.serializedData, key);
    const refreshNotifications = () => {
        if (accountInfo.role === 1) {
            getNotifications().then((n) => setNotifications(n));
        }
    }
    useEffect(() => {
        subscribe("messageIgnored", () => { refreshNotifications(); });
        refreshNotifications();
        
    }, []);
   
    const hasAnyNotifications = () => notifications?.filter(x => !x.hidden)?.length > 0;
    return (
        <div className="vh-100" style={{ display: 'flex' }}>
            <Popover
                
                open={anchorEl!=null}
                anchorEl={anchorEl}
                onClose={()=>setAnchorEl(null)}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'right',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                }}                
            >
                

                {hasAnyNotifications() ? <Stack>
                    <Stack style={{ overflowY: "scroll", maxHeight: "200px",maxWidth:"500px" }}>
                        {notifications?.filter(x => !x.hidden).map((x, i) =>
                        (<Stack key={i} direction="horizontal" style={{ margin: 8 }} gap={3}>
                            <FontAwesomeIcon icon={solid("info")}/>
                            <Stack>
                                <Link to={"/administration/users/" + deserialize(x.serializedData, "userId")} replace>{(getKey(x, "username") ? getKey(x, "username") : t("thisUser"))}</Link>
                                {t(getKey(x, "reason"))}
                                {(getKey(x, "reason") === "notificationMessageSent" && getKey(x, "message")) &&
                                    <b>{getKey(x,"message") }</b>
                                }
                                {(getKey(x, "reason") === "profileChanged" && getKey(x, "changed")) &&
                                    <b>{getKey(x, "changed")?.map(x => x.charAt(0).toLowerCase() + x.slice(1))?.map(x=>t(x))?.join(", ")}</b>
                                }
                                <small>{formatDateTime(x.created)}</small>
                            </Stack>
                            <Button onClick={(e) => {
                                x.hidden = true;
                                setAnchorEl(null)
                                markNotificationAsRead(x.id).then(() => {
                                    publish("notificationIgnored", x);
                                });
                            }} ><FontAwesomeIcon icon={solid("xmark")} /></Button>
                        </Stack>)
                        )}


                    </Stack>
                    <Button style={{ margin: 4 }} className="btn-secondary" onClick={() => {
                        notifications?.forEach(n => {
                            n.hidden = true;
                        })
                        setAnchorEl(null);
                        markNotificationAsRead(-1);
                    }}>{t("markAllAsRead")}</Button>
                </Stack>
                    :
                    <div style={{ margin:15 }}>{t("noNotifications")}</div>
                }

                                    
                
            </Popover>

            <NavMenu style={{ order: 1 }} />
            <section style={{ order: 2, width: '100%' }}>
                


                <Navbar bg="light">
                    <Container className="my-0" style={{ marginLeft: "16px" }}>
                        <Navbar.Brand>
                            <Stack direction="horizontal" gap={4}>
                                <FontAwesomeIcon icon={solid("bars")} style={{ color: "#d12b3c" }} onClick={toggleSidebar} />                                
                            </Stack>
                        </Navbar.Brand>


                        <Nav className="justify-content-end flex-grow-1 pe-3" onSelect={handleSelection}>
                            <Nav.Link href="#"><Flag code={t("countryCode")} height="20" width="20" /></Nav.Link>
                            <NavDropdown align="end" title={i18n.language.toUpperCase()}>
                                <NavDropdown.Item href="#" eventKey="en">{t('english')}</NavDropdown.Item>
                                <NavDropdown.Item href="#" eventKey="fr">{t('french')}</NavDropdown.Item>
                            </NavDropdown>

                            {accountInfo.role == 1 && <Nav.Link href="#">
                                <Button className="btn-secondary" onClick={(event) => { setAnchorEl(event.currentTarget) }}>
                                    <FontAwesomeIcon icon={solid("bell")} />
                                    {hasAnyNotifications() && <span>&nbsp;&nbsp;&nbsp;<Badge bg="danger">{notifications?.filter(x => !x.hidden)?.length}</Badge></span>}
                                </Button>
                            </Nav.Link>}



                            <NavDropdown
                                align="end"
                                title={<div style={{ display: "inline-block", }}><Stack>
                                    <span><b>{accountInfo?.name}</b></span>
                                    <span>{getUserType(accountInfo?.role)}</span>
                                </Stack></div>}
                            >
                                {accountInfo.role == 3 && <NavDropdown.Item href="#" eventKey="profile">{t('myProfile')}</NavDropdown.Item>}
                                <NavDropdown.Item href="#" eventKey="logout">{t('logout')}</NavDropdown.Item>
                            </NavDropdown>
                        </Nav>
                    
                    </Container>
                </Navbar>


                

                <section style={{
                    backgroundColor: "#F2F3F8",
                    padding: '1rem',
                    overflowY: 'scroll',
                    overflowX: 'hidden',
                    maxHeight: 'calc(100vh - 76px)',
                    minHeight: 'calc(100vh - 76px)'
                }}>
                    <Stack gap={2} style={{ paddingTop: "0px" }} >                        
                        {children}
                    </Stack>

                            
                    
                </section>
            </section>
        </div>
    );
}

export default PrivateLayout;